import React from 'react'
import PropTypes from 'prop-types'
import { Box as FableBox } from '@sainsburys-tech/fable'
import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

const Box = ({ children, rounded, removeMobileTopBorders, className, removeMobileBottomBorders }) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()

  const childrenArray = React.Children.toArray(children)
  if (childrenArray.length === 0) return null

  if (!PDP_V2_FLAG) return children

  const borderStyle =
    rounded &&
    `ds-rounded-xl ${
      removeMobileTopBorders ? 'ds-rounded-tl-none ds-rounded-tr-none md:ds-rounded-tl-xl md:ds-rounded-tr-xl' : ''
    }  ${
      removeMobileBottomBorders ? 'ds-rounded-bl-none ds-rounded-br-none md:ds-rounded-bl-xl md:ds-rounded-br-xl' : ''
    }`

  return (
    <FableBox
      as='section'
      className={`ds-mb-4 ds-shadow-md ds-w-full ${borderStyle} ${className.trim() || ''}`}
      padding={{ md: 'sm' }}
      backgroundColor='white'
    >
      {children}
    </FableBox>
  )
}

Box.propTypes = {
  children: PropTypes.node,
  rounded: PropTypes.bool,
  removeMobileTopBorders: PropTypes.bool,
  removeMobileBottomBorders: PropTypes.bool,
  className: PropTypes.string
}

Box.defaultProps = {
  children: null,
  rounded: true,
  removeMobileTopBorders: false,
  removeMobileBottomBorders: false,
  className: ''
}

export default Box
